import InnerPageResume from './innerPageResume'
import TemplateMain from '../templateMain'
import { SLIDESHOWS } from '../../types'
export default function PageResume () {
  return (
    <TemplateMain
      g_section='resume'
      htmlTitle='Resume'
      linksTitle='Download Resume'
      innerPage={<InnerPageResume />}
      g_sidebarKey='pageResume'
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
